import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import { formatoSeparadorMilesValueExtracto } from "../../generico/utils/FormatoInput";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import Select from "react-select";
import Popup from "react-popup";
import ExtractoServices from "../../../services/consultas/ExtractoService";
import MensajeUsuario from "../../generico/MensajeUsuario";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faPrint } from "@fortawesome/free-solid-svg-icons";

export default class ExtractoTarjeta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaPeriodo: [],
      periodoElegido: null,
      detalle: [],
      cabecera: {},
    };
  }
  componentDidMount() { }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  //###################### LISTA MES/AÑO ###########################//

  obtenerListaPeriodo = () => {

    var list = [];
    list.push({
      value: "masterHoy",
      label: "Extracto a la fecha",
    });

    var nroTarjeta = sessionStorage.getItem("nroTarjeta");
    trackPromise(
      ExtractoServices.ciclos(nroTarjeta)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(response);
          if (jsonData.codigo === "0") {
            var periodos = jsonData.periodos;
            for (var i = 0; i < periodos.length; i++) {
              /*list.push({
                value: periodos[i].periodo,
                label: this.formatStringToDate(periodos[i].periodo),
              });*/
              list.push({
                value: periodos[i].periodo,
                label: periodos[i].periodo,
              });
            }
          } else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
            return;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaPeriodo: list });
    return list;
  };

  formatStringToDate(toFormat) {
    var respuesta =
      toFormat.substring(0, 4) +
      "/" +
      toFormat.substring(4, 6) +
      "/" +
      toFormat.substring(6);
    return respuesta;
  }

  handleChangePeriodoSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        periodoElegido: null,
        detalle: [],
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value,
      });
    }
  };

  getListaExtracto() {
    console.log(this.state.periodoElegido)
    if (this.state.periodoElegido === null) {
      Popup.queue(this.notifiPopup("Info", "Debe seleccionar un periodo de consulta"));
      return null;
    }
    //var nroTarjeta = sessionStorage.getItem("resumen");
    var nroTarjeta = sessionStorage.getItem("nroTarjeta");
    var jCab = {};
    var tarjetasExtras = [];

    if (this.state.periodoElegido === "masterHoy") {
      this.setState({ labelSaldo: "SALDO FINANCIADO" });
      trackPromise(
        ExtractoServices.masterHoyCu(nroTarjeta)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);

            if (jsonData.codigo === "0") {

              for (let index = 0; index < jsonData.resultado.length; index++) {
                if (jsonData.resultado[index].tipoTransaccion === "Credito") {
                  jsonData.resultado[index].importeGuaranies = "-" + jsonData.resultado[index].importeGuaranies;
                }
              }
              var det = jsonData.resultado;
              //this.setState({ tarjetasExtras: tarjetasExtras});
              jCab = {
                nombreCompleto: jsonData.titular,
                tarjeta: sessionStorage.getItem("resumen"),
                tarjetaAdicional: "",
                clase: jsonData.clase,
                moneda: "GUARANIES"
              };
              this.setState({ cabecera: jCab, detalle: det });
            } else {
              this.setState({ cabecera: {}, detalle: [] });
              Popup.queue(this.notifiPopup("Info", jsonData.mensaje));

              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    } else {
      this.setState({ labelSaldo: "SALDO" });
      var windowsReference =  window.open();
      trackPromise(
        ExtractoServices.masterAnteriorPdf(nroTarjeta, this.state.periodoElegido)
          .then((response) => {
            if (response.data.size === 0) {
              Popup.queue(this.notifiPopup("Info", "No se pudo encontrar el extracto de la tarjeta en el periodo seleccionado"));
              return;
            }
            var fileURL = URL.createObjectURL(response.data);
            windowsReference.location = fileURL;
          })
          .catch(function (error) {
            windowsReference.close();
            console.log(error);
          })
      );

      /*trackPromise(
        ExtractoServices.masterAnterior(nroTarjeta, this.state.periodoElegido)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {
              var fecha = this.state.periodoElegido;
              var fechaFormateada = fecha.substring(6, 8)+"/"+fecha.substring(4,6)+"/"+fecha.substring(0,4);
              var det = jsonData.resultadosDetalles;  
              for (let index = 0; index < jsonData.resultadosClientes.length; index++) {
                if(jsonData.resultadosClientes[index].tipoTarjeta === "A"){
                  tarjetasExtras.push(jsonData.resultadosClientes[index]);
                }
                
              }
              this.setState({ tarjetasExtras: tarjetasExtras});
              jCab = {
                nombreCompleto: jsonData.nombreCompleto,
                tarjeta: jsonData.resultadosClientes[0].nroTarjeta,
                clase: jsonData.clase,
                moneda: jsonData.moneda,
                lineaCredito: formatoSeparadorMilesValueExtracto(jsonData.lineaCredito),
                disponibilidadCompraN: formatoSeparadorMilesValueExtracto(
                  jsonData.saldoDisponible
                ),
                disponibilidadCompraC: formatoSeparadorMilesValueExtracto(
                  jsonData.saldoAnterior
                ),
                pagoMinimoPendiente: formatoSeparadorMilesValueExtracto(
                  jsonData.pagoMinimo
                ),
                deudaTotal: formatoSeparadorMilesValueExtracto(jsonData.deudaTotal),
                fechaProximoCierre: fechaFormateada,
                fechaVencimientoPagoMinimo: jsonData.fechaVencimientoPagoMinimo,
                interesCorriente: formatoSeparadorMilesValueExtracto(
                  jsonData.interesCorriente
                ),
                interesMoratorio: formatoSeparadorMilesValueExtracto(
                  jsonData.interesMoratorio
                ),
                iva10: formatoSeparadorMilesValueExtracto(jsonData.iva10),
                iva5: formatoSeparadorMilesValueExtracto(jsonData.iva5),
                gastosFinancieros: formatoSeparadorMilesValueExtracto(
                  jsonData.gastosFinancieros
                ),
                fechaPagoMinimo: jsonData.fechaPagoMinimo,
              };
              this.setState({ cabecera: jCab, detalle: det });
            } else {
              this.setState({ cabecera: {}, detalle: [] });
              Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));

              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );*/
    }
  }

  formatearImporte(value) {
    var monto = value.split("-");
    if (monto.length > 1) {
      monto = "-" + monto[1];
    } else {
      monto = value;
    }
    return formatoSeparadorMilesValueExtracto(monto);
  };

  dibujarExtracto() {
    return this.dibujarExtractoMaster();
  }

  imprimirExtracto(idDiv) {
    var contenido = document.getElementById(idDiv).innerHTML;
    var contenidoOriginal = document.body.innerHTML;
    document.body.innerHTML = contenido;
    window.print();
    document.body.innerHTML = contenidoOriginal;
  }

  dibujarExtractoMaster() {
    if (this.state.periodoElegido === "masterHoy") {

      const cab = this.state.cabecera;
      const det = this.state.detalle;

      const detalle = det !== null ? det.map((item, index) => (
        <tr key={index}>
          <td className="detalle">{item.numeroTarjeta}</td>
          <td className="detalle">{item.fechaTransaccion}</td>
          <td className="detalle">{item.comercio}</td>
          <td className="detalle">{item.tipoTransaccion}</td>
          <td className="detalle"> {this.formatearImporte(item.importeGuaranies)}</td>
        </tr>
      )) : <td></td>;

      if (this.state.detalle !== null && this.state.detalle.length === 0) {
        return <div></div>;
      }

      return (
        <div className="col-md-12" style={{ textAlign: "right" }}>
        <div className="extracto-mastercard" id="extracto-mastercard">
         
            <div className="card">
              <div className="card-header">
              <div className="row">
                <div className="col-md-8">
                <div style={{float: "left"}}>
               
                <span className="titulo" style={{ fontSize: "1.5rem" }}>
                  Extracto de MasterCard
                </span>
              </div>
                </div>
                <div className="col-md-4">
               
                <button
                  className="btn btn-cu-primary float-right"
                  onClick={() => this.imprimirExtracto("extracto-mastercard")}
                >
                 <FontAwesomeIcon icon={faPrint} /> Imprimir
                </button>
                
             
                </div>
              </div>
              </div>
           
              <div className="card-body">
                {/*this.state.detalle !== null && this.state.detalle.length > 0 ? */(
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-12">
                          <MensajeUsuario tipo="INFO"
                            titulo="Considerar."
                            mensaje="Los montos por sus compras en el exterior que figuren en esta consulta,
                            pueden variar en su extracto del mes por la cotización." />
                        </div>
                      </div>
                      <div className="row separador-agente">
                        <div className="col-md-3 img-printer">
                          <img
                            src="dist/img/credit/mastercard_logo.png"
                            style={{ width: 120 }}
                          />
                        </div>
                        <div className="col-md-6 img-printer">
                          <img
                            src="dist/img/Logo_CU_Verde.PNG"
                            style={{ width: 180 }}
                          />
                        </div>
                        <div
                          className="col-md-3"
                          style={{ paddingTop: 20, textAlign: "end" }}
                        >
                          <span style={{ fontSize: "1rem", fontWeight: "500" }}>
                            TITULAR
                          </span>
                          <br />
                          {cab.nombreCompleto}
                        </div>
                      </div>
                      <div className="row border">
                        <div className="col-md-12">
                          <span className="cabecera">TARJETA</span>{" "}
                          <span className="detalle"> {cab.tarjeta}</span> -{" "}
                          <span className="cabecera">CLASE</span>{" "}
                          <span className="detalle">
                            {cab.clase} ( {cab.moneda})
                          </span>
                        </div>
                      </div>

                      <br />

                      <div className="row">
                        <div className="col-md-12">
                          <div className="row  table-responsive">
                            <table className="table border">
                              <thead>
                                <tr>
                                  <th className="cabecera">Número de tarjeta</th>
                                  <th className="cabecera">Fecha Operación</th>
                                  <th className="cabecera">Comercio</th>
                                  <th className="cabecera">Tipo</th>
                                  <th className="cabecera">Monto</th>
                                </tr>
                              </thead>
                              {detalle !== null && detalle.length > 0 ? <tbody>{detalle}</tbody> : <tbody></tbody>}
                            </table>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                ) /*: (
                    <div></div>
                )*/}
              </div>
            </div>
          </div>
        </div>
      );

    } else if (this.state.periodoElegido !== null && this.state.periodoElegido === "masterHoy") {
      const cab = this.state.cabecera;
      const det = this.state.detalle;
      console.log(det)
      const labelSaldo = this.state.labelSaldo;
      var tarjetasExtras = this.state.tarjetasExtras;
      const detalle = det !== null ? det.map((item, index) => (
        <tr key={index}>
          <td className="detalle">{item.fechaOperacion}</td>
          <td className="detalle">{item.fechaProceso}</td>
          <td className="detalle">{formatoSeparadorMilesValueExtracto(item.nroCupon)}</td>
          <td className="detalle">{item.descripcion}</td>
          <td className="detalle"> {this.formatearImporte(item.importe)}</td>
        </tr>
      )) : <td></td>;
      if (this.state.detalle !== null && this.state.detalle.length === 0) {
        return <div></div>;
      }

      return (
        <div className="row extracto-mastercard" id="extracto-mastercard">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <button
                  className="btn btn-cu-primary float-right"
                  onClick={() => this.imprimirExtracto("extracto-mastercard")}
                >
                  Imprimir
                </button>
                <span className="titulo" style={{ fontSize: "1.5rem" }}>
                  Extracto de MasterCard
                </span>
              </div>
              <div className="card-body">
                {/*this.state.detalle !== null && this.state.detalle.length > 0 ? */(
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-3">
                          <img
                            src="dist/img/credit/mastercard_logo.png"
                            style={{ width: 120 }}
                          />
                        </div>
                        <div className="col-md-6" style={{ textAlign: "center" }}>
                          <img
                            src="/Logo_CU_Verde.PNG"
                            style={{ width: 200 }}
                          />
                        </div>
                        <div
                          className="col-md-3"
                          style={{ paddingTop: 20, textAlign: "end" }}
                        >
                          <span style={{ fontSize: "1rem", fontWeight: "500" }}>
                            TITULAR
                          </span>
                          <br />
                          {cab.nombreCompleto}
                        </div>
                      </div>
                      <div className="row border">
                        <div className="col-md-12">
                          <span className="cabecera">TARJETA</span>{" "}
                          <span className="detalle"> {cab.tarjeta}</span> -{" "}
                          <span className="cabecera">CLASE</span>{" "}
                          <span className="detalle">
                            {cab.clase} ( {cab.moneda})
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="row">
                            <div className="col-md-12 border">
                              <span className="cabecera">
                                COMPRAS NORMALES Y EN CUOTAS
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 border">
                              <span className="cabecera">LÍNEA TOTAL</span>
                              <br />
                              <span className="detalle"> {cab.lineaCredito}</span>
                            </div>
                            <div className="col-md-6 border">
                              <span className="cabecera">DISPONIBLE</span>
                              <br />
                              <span className="detalle">
                                {cab.disponibilidadCompraN}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="row">
                            <div className="col-md-12 border">
                              <span className="cabecera">SALDOS</span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3 border">
                              <span className="cabecera">{labelSaldo}</span>
                              <br />
                              <span className="detalle">
                                {cab.disponibilidadCompraC}
                              </span>
                            </div>
                            <div className="col-md-3 border">
                              <span className="cabecera">PAGO MÍNIMO</span>
                              <br />
                              <span className="detalle">
                                {cab.pagoMinimoPendiente}
                              </span>
                            </div>
                            <div className="col-md-3 border">
                              <span className="cabecera">DEUDA TOTAL</span>
                              <br />
                              <span className="detalle">{cab.deudaTotal}</span>
                            </div>
                            <div className="col-md-3 border">
                              <span className="cabecera">FECHA CIERRE</span>
                              <br />
                              <span className="detalle">
                                {cab.fechaProximoCierre}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <br />
                      {tarjetasExtras.map(elemento =>
                        <div className="row">
                          <div className="col-md-12 border">
                            <span className="cabecera">TARJETA ADICIONAL</span>{" "}
                            <span className="detalle">{elemento.nroTarjeta}</span>
                          </div>
                        </div>
                      )}
                      <br />

                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <table className="table border">
                              <thead>
                                <tr>
                                  <th className="cabecera">Fecha Operación</th>
                                  <th className="cabecera">Fecha Proceso</th>
                                  <th className="cabecera">Nro. cupón</th>
                                  <th className="cabecera">Detalle</th>
                                  <th className="cabecera">Monto</th>
                                </tr>
                              </thead>
                              {detalle !== null && detalle.length > 0 ? <tbody>{detalle}</tbody> : <tbody></tbody>}
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          {this.state.periodoElegido !== "masterHoy" && (
                            <div
                              ref={(a) => (this.footerDetail = a)}
                              className="row"
                            >
                              <div className="col-md-3 border">
                                <span className="cabecera">Int. Corriente +</span>
                                <br />
                                <span className="detalle">
                                  {cab.interesCorriente}
                                </span>
                              </div>
                              <div className="col-md-3 border">
                                <span className="cabecera">Int. Moratorio +</span>
                                <br />
                                <span className="detalle">
                                  {cab.interesMoratorio}
                                </span>
                              </div>
                              <div className="col-md-2 border">
                                <span className="cabecera">IVA 10% +</span>
                                <br />
                                <span className="detalle">{cab.iva10}</span>
                              </div>
                              <div className="col-md-2 border">
                                <span className="cabecera">IVA 5%=</span>
                                <br />
                                <span className="detalle">{cab.iva5}</span>
                              </div>
                              <div className="col-md-2 border">
                                <span className="cabecera">Total Factura</span>
                                <br />
                                <span className="detalle">
                                  {cab.gastosFinancieros}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row border">
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <span className="cabecera">TALÓN DE PAGO</span>
                                </div>
                                <div className="col-md-12">
                                  <span className="detalle">EFECTIVO</span>
                                </div>
                                <div className="col-md-12">
                                  <span className="detalle">
                                    CHEQUE NRO. C/ BANCO
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-6 border">
                                  <span className="cabecera">
                                    Vencimiento Pag. Mínimo
                                  </span>
                                  <br />
                                  <span className="detalle">
                                    {cab.fechaVencimientoPagoMinimo}
                                  </span>
                                </div>
                                <div className="col-md-6 border">
                                  <span className="cabecera">
                                    Tarjeta de Crédito No.
                                  </span>
                                  <br />
                                  <span className="detalle">{cab.tarjeta}</span>
                                </div>
                                <div className="col-md-6 border">
                                  <span className="cabecera">Fecha de Pago</span>
                                  <br />
                                  <span className="detalle">-</span>
                                </div>
                                <div className="col-md-3 border">
                                  <span className="cabecera">Pago mínimo.</span>
                                  <br />
                                  <span className="detalle">
                                    {cab.pagoMinimoPendiente}
                                  </span>
                                </div>
                                <div className="col-md-3 border">
                                  <span className="cabecera">Monto abonado.</span>
                                  <br />
                                  <span className="detalle">-</span>
                                </div>
                              </div>
                            </div>
                            <div hidden className="col-md-12 border">
                              <span className="cabecera">SON GUARANÍES:</span>
                              <span className="detalle">
                                {" "}
                                QUINIENTOS MIL NO SE QUE CUANTO GUARANIES
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) /*: (
                    <div></div>
                )*/}
              </div>
            </div>
          </div>
        </div>
      );
    }

  }

  getColumnMovimientoTarjetaMaster() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
      },
      {
        name: "Número",
        selector: row => row.numero,
      },
      {
        name: "Descripción",
        selector: row => row.descripcion,
        width: "400px",
      },
      {
        name: "Débito",
        selector: row => row.debito,
        right: true,
        width: "100px",
      },
      {
        name: "Crédito",
        selector: row => row.credito,
        right: true,
        width: "100px",
      },
      {
        name: "Saldo",
        selector: row => row.saldo,
        right: true,
        width: "100px",
      },
    ];
  }

  render() {
    var list = this.state.listaPeriodo;

    if (this.state.listaPeriodo.length === 0) list = this.obtenerListaPeriodo();

    return (
      <div className="content-wrapper">
        <Titulo texto="Extracto de Tarjeta" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{zIndex:1}} >
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                      <label className="input-label-bold">Mes/Año *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangePeriodoSelector}
                            options={list}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                      <button
                          className="btn btn-cu-primary"
                          onClick={() => this.getListaExtracto()}
                        >
                         <FontAwesomeIcon icon={faCheck} />  Consultar
                        </button>
                      </div>
                    </div>
                  </div>
               
                </div>
              </div>
            </div>
            {this.dibujarExtracto()}
          </div>
        </section>
      </div>
    );
  }
}
